'use client';
import React from 'react';

import ErrorPage from '@webteam/error-page';

import DarkThemeEnforcer from '@/components/common/DarkThemeEnforcer/DarkThemeEnforcer';
import IaTypography from '@/components/common/webteam/IaTypography/IaTypography';

import styles from './errors.module.scss';

export const dynamic = 'force-static';

const NotFoundPage: React.FC = () => {
  return (
    <ErrorPage
      className={styles.error}
      codeError="404"
      links={[{ value: '/', label: 'JetBrains Internship' }]}
      text="You surely know what this means."
      title="Uh-oh!"
    >
      <IaTypography theme="dark" variant="rs-text-1">
        We can't find the page you're looking for. Please use search or try
        starting from home.
      </IaTypography>
      <DarkThemeEnforcer />
    </ErrorPage>
  );
};

export default NotFoundPage;
